<template>
  <div class="-numeric-text">
    <input
        type="text"
        ref="input"
        :value="value"
        :disabled="disabled"
        @change="updateValue($event.target.value); $event.target.blur();"
    >
  </div>
</template>

<script>
import isString from 'lodash/isString';
import isFunction from 'lodash/isFunction';
import isNaN from 'lodash/isNaN';
import noop from 'lodash/noop';
import flow from 'lodash/flow';
export default {
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },

    max: {
      type: Number,
      default: 100,
    },

    min: {
      type: Number,
      default: 0,
    },

    step: {
      type: Number,
      default: 1,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    format: {
      type: Function,
      default: (value) => parseFloat(value),
    },
  },

  data() {
    return {
      lastValue: this.value,
    };
  },

  mounted() {
    this.updateValue(this.value);
  },

  methods: {
    trimValue(value) {
      return isString(value) ? value.trim() : value;
    },

    isNan(value) {
      return isNaN(value) ? this.lastValue : value;
    },

    inRange(value) {
      if (value > this.max) {
        return this.max;
      } else if (value < this.min) {
        return this.min;
      }
      return parseFloat((Math.round(value / this.step) * this.step).toFixed(2));
    },

    updateValue(value) {
      const formatter = flow(
        this.trimValue,
        isFunction(this.format) ? this.format : noop,
        this.isNan,
        this.inRange
      );

      const formattedValue = formatter(value);

      this.$refs.input.value = formattedValue;
      this.$emit('input', formattedValue);
      this.lastValue = formattedValue;
    },
  },
};
</script>
